export const ORDER_HEADERS = {
  'Octo-Capabilities': 'octo/cart,octo/pricing,octo/cardPayments,octo/gifts,octo/offers,octo/content,octo/questions',
}
